/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {isObject} from '../../../utils';

const notification = (state, action) => {
  const actionTypeInfo = action.type.split('_');
  const notificationType = actionTypeInfo[actionTypeInfo.length - 1];

  switch (notificationType) {
    case 'FAILURE':
      return {
        message: isObject(action.error) ? action.error.message : action.error,
        title: action.title || action.type,
        level: 'error',
        time: Date.now()
      };
    case 'ALERT':
      return {
        message: isObject(action.alert === 'object') ? action.alert.message : action.alert,
        title: action.title || action.type,
        level: 'warning',
        time: Date.now()
      };
    case 'INFO':
      return {
        message: isObject(action.info === 'object') ? action.info.message : action.info,
        title: action.title || action.type,
        level: 'info',
        time: Date.now()
      };
    case 'SUCCESS':
      return {
        message: isObject(action.success === 'object') ? action.success.message : action.success,
        title: action.title || action.type,
        level: 'success',
        time: Date.now()
      };
    default:
      return {};
  }
};

export default notification;